import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { IS_DESKTOP, IS_MOBILE } from '@core/tokens/tokens';
import { ButtonComponent } from '@shared/components/button/button.component';
import { APPLICATION_ROUTES, STARTING_USER_ROUTES } from '@core/consts/routes';
import { UserStateService } from '@core/services/authApiService/user-state-service.service';
import { PopupService } from '@shared/services/popup.service';
import { PopupTypes } from '@core/consts/popups';
import { SignOutComponent } from '@shared/components/sign-out/sign-out.component';
import { UserHeaderComponent } from '@pages/common/user-header/user-header.component';
import { UserRoles } from '@core/consts/userRoles';

@Component({
  selector: 'mdcr-header-action-content',
  imports: [ButtonComponent, RouterLink, SignOutComponent, UserHeaderComponent],
  templateUrl: './header-action-content.component.html',
  styleUrl: './header-action-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderActionContentComponent {
  public readonly isDesktop = inject(IS_DESKTOP);
  public readonly isMobile = inject(IS_MOBILE);

  private readonly authService = inject(UserStateService);

  private readonly popupService = inject(PopupService);

  public readonly isLogged = this.authService.isLoggedIn;
  public readonly userRole = this.authService.role();

  public readonly APPLICATION_ROUTES = APPLICATION_ROUTES;
  public readonly UserRoles = UserRoles;
  public readonly STARTING_USER_ROUTES = STARTING_USER_ROUTES;

  public openModal(): void {
    this.popupService.openPopup(PopupTypes.CONFIRM_SIGN_OUT);
  }

  public getPortalRoute(): string {
    const route = STARTING_USER_ROUTES[this.userRole];
    return `/${route}`;
  }
}
